export async function signPsbt(client, params) {
    const data = await client.request({
        method: 'signPsbt',
        params: params,
    }, { dedupe: true });
    return data;
}
//# sourceMappingURL=signPsbt.js.map